var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"list"}},[_c('general-form-list-component',{attrs:{"get-items-function":_vm.getItems,"delete-item-function":_vm.deleteItem,"create-item-function":_vm.createItem,"form-name":"general_skaly_po"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }